import Marquee, { MarqueeDirections } from "../components/Marquee";
import { debounce } from "../inc/helpers";

export default class PageParts {
  constructor() {
    this.data = null;
    this.observer = null;
  }

  init(data) {
    this.data = data;
    
    this.init_marquees();
        
    this.observer = new IntersectionObserver(this.showBrandCards.bind(this), {
      threshold: [0.8],
    });

    this.initCards();
    this.initBrandTableTabs();
  }

  /**
   * to refactor: cleanup of duplicated els to fix bug on resize
   */
  init_marquees() {
    const marquees = document.querySelectorAll(".js-marquee");
    const gap = 
      parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")) * 1.25;
    
    marquees?.forEach((m, i) => {
      let words = i % 2 === 0 ? Array.from(m.children) : Array.from(m.children).reverse();
      
      if (!words.length > 0) return;
      
      const total_words_width = words.reduce((sum, w) => sum + w.offsetWidth, 0);
      const clone_and_append = () => {
        words.forEach(w => m.appendChild(w.cloneNode(true)));
        words = Array.from(m.children);
        const total_words_width = words.reduce((sum, w) => sum + w.offsetWidth, 0);

        if (total_words_width <= window.innerWidth) {
          clone_and_append();              
        } 
      };
      
      if (total_words_width <= window.innerWidth) {
        clone_and_append();              
      } 

      // merda
      if (i % 2 !== 0) {
        clone_and_append();
        clone_and_append();
      }

      let j = 0, k = 0, x = 0;

      const translate = () => {
        m.style.setProperty("transform", `translateX(${j * -1}px)`);

        if (i % 2 === 0) {
          if (j > x + words[k].offsetWidth) {     
            const clone = words[k].cloneNode(true);
            m.appendChild(clone);
            words.push(m.lastChild);
            
            k++;
            x += words[k].offsetWidth + gap;
          }
  
          j++;
        
        } else {
          if (j * -1 > x + words[k].offsetWidth) {
            const clone = words[k].cloneNode(true);
            m.insertBefore(clone, m.firstChild);
            words.push(m.querySelector(".marquee-word:last-child"));
            
            k++;
            x += words[k].offsetWidth + gap;
          }

          j--;
        }
      };

      let interval = setInterval(translate, 25);

      window.addEventListener("resize", debounce((e) => {
        clearInterval(interval);
        j = 0, k = 0, x = 0;              
        m.style.setProperty("transform", "none");
        
        interval = setInterval(translate, 25);
      }));
    });
  }
  
  /**
   * Inizializza le card e aggiunge un observer per far partire un'animazione quando entrano nella view
   */
  initCards() {
    const brandCardsList = document.querySelectorAll(".js-brand");
    for (let brandCard of brandCardsList) {
      this.observer.observe(brandCard);
    }
  }

  /**
   * Inizializza le tab per filtrare le card dei brand.
   */
  initBrandTableTabs() {
    const tabButtons = document.querySelectorAll(".js-btn-tab");
    for (let button of tabButtons) {
      button.addEventListener("click", this._onClickTabButton.bind(this));
    }
  }

  /**
   * Gestisce l'evento onClick sulle tab.
   */
  _onClickTabButton(event) {
    this.observer.disconnect();
    const { target } = event;
    const tabType = target.getAttribute("data-type");
    const activeTab = document.querySelector('.js-btn-tab.is-current');
    if(activeTab){
      activeTab.classList.remove('is-current');
    }
    target.classList.add('is-current');
    this._filterBrandCards(tabType);
    this.initCards();
  }

  /**
   * Filtra le card in base alla tab selezionata
   * @param {string} selectedTabType tipo della tab selezionata
   */
  _filterBrandCards(selectedTabType) {
    const brandCards = document.querySelectorAll(".js-brand");
    for (let brandCard of brandCards) {
      const types = brandCard.getAttribute("data-type")?.split(",").map(s => s.trim().toLowerCase());
      
      if (selectedTabType === "all") {
        brandCard.style.display = "flex";
        brandCard.classList.remove('shown');
        continue;
      }
      
      if (!types) {
        brandCard.style.display = "none";
        continue;
      }
      
      if (types.includes(selectedTabType)) {
        brandCard.style.display = "flex";
        brandCard.classList.remove('shown');
        
      } else {
        brandCard.style.display = "none";
        brandCard.classList.remove('shown');  
      }
    }
  }

  /**
   * Aggiunge la classe "shown" alle card da mostrare
   * @param {*} entries oggetto che contiene tutte le card controllate dall'observer 
   */
  showBrandCards(entries) {
    let intersectingItemsCount = 0;
    let intersectedForTheFirstTime = false;
    let firstIndex = 0;
    for (let entry of entries) {
      if (entry.isIntersecting && !entry.target.classList.contains("shown")) {
        if (!intersectedForTheFirstTime) {
          firstIndex = entries.indexOf(entry);
          intersectedForTheFirstTime = true;
        }
        const timeoutTime = 100 * intersectingItemsCount;
        const timeout = setTimeout(() => {
          entry.target.classList.add("shown");
          clearTimeout(timeout);
        }, [timeoutTime]);
        intersectingItemsCount++;
        this.observer.unobserve(entry.target);
      }
    }

    if (entries.length > intersectingItemsCount) {
      this._showPreviousBrandCards(firstIndex);
    }
  }

  /**
   * Mostra tutte le card precedenti alla prima visibile.
   * @param {number} index indice della prima card visibile
   */
  _showPreviousBrandCards(index) {
    const brandCardsList = document.querySelectorAll(".brand-card");

    for (let i = 0; i < index && i < brandCardsList.length; i++) {
      brandCardsList[i].classList.add("shown");
      this.observer.unobserve(brandCardsList[i]);
    }
  }
}